export enum DialogAction {
  Initial,
  Edit,
  New,
}
